const FRAME_RATE = 30

{
  const BaseModule = require('_base/base')

  class PlayableSvg extends BaseModule {
    postInit() {
      this.$svg = this.$el[0].querySelector('svg')

      this.viewBox = this.$svg.viewBox.baseVal
      this.duration = parseFloat(this.$el.data('duration'), 10)
      this.paths = this.parsePaths()
      this.totalLength = this.getTotalLength()
      this.frameStep = FRAME_RATE / this.duration / 1000

      this.bindEvents()
      this.calculatePaths()
    }

    postCalculate() {
      this.width = this.$svg.clientWidth
      this.height = this.$svg.clientHeight

      this.widthRatio = this.width / this.viewBox.width
      this.heightRatio = this.height / this.viewBox.height
    }

    postRender() {
      if (!this.isPlayed) this.play(0)
    }

    bindEvents() {
      this.$spread.on('spreadOutOfSight', (_, data) => {
        if (data.direction < 0) this.resetPosition()
      })

      this.$spread.on('spreadActivated', () => {
        if (!this.isPlayed) this.play(0)
      })
    }

    resetPosition() {
      clearTimeout(this.animationTimeout)
      this.isPlayed = false
      this.paths.forEach(path => {
        path.$el.style.strokeDashoffset = path.length

        if (path.fillAt) path.$el.style.stroke = 'none'
      })
    }

    play(progress) {
      if (progress > 1) progress = 1

      const currentLength = this.totalLength * progress

      this.paths.forEach(path => {
        if (currentLength >= path.start) {
          if (currentLength < path.end) {
            path.$el.style.strokeDashoffset = path.end - currentLength

            this.emitUpdateEvent(path.$el.getPointAtLength(currentLength - path.start))
          } else {
            path.$el.style.strokeDashoffset = 0
          }
        }

        if (path.fillAt && currentLength >= path.fillAt) {
          path.$el.style.stroke = '#fff'
        }
      })

      if (progress < 1) {
        clearTimeout(this.animationTimeout)
        this.animationTimeout = setTimeout(() => this.play(progress + this.frameStep), FRAME_RATE)
      } else {
        this.$el.trigger('positionUpdated', {
          x: this.width * 1.5,
          y: this.height * 1.5,
        })
      }

      this.isPlayed = true
    }

    parsePaths() {
      return [...this.$svg.querySelectorAll('path')].map($path => {
        const fillAt = $path.getAttribute('fill-at')
        const length = fillAt ? 0 : $path.getTotalLength()
        $path.style.strokeDasharray = `${length} ${length}`
        $path.style.strokeDashoffset = length

        return {
          $el: $path,
          length: length,
          fillAt: fillAt,
        }
      })
    }

    getTotalLength() {
      return this.paths.filter(path => !path.fillAt).reduce((totalLength, path) => {
        return totalLength + path.length
      }, 0)
    }

    calculatePaths() {
      let prevEnd = 0

      this.paths.forEach(path => {
        path.$el.style.strokeDasharray = `${path.length} ${path.length}`
        path.$el.style.strokeDashoffset = path.length

        path.start = prevEnd
        path.end = path.start + path.length

        prevEnd = path.end
      })
    }

    emitUpdateEvent(coords) {
      this.$el.trigger('positionUpdated', {
        x: coords.x * this.widthRatio,
        y: coords.y * this.heightRatio,
      })
    }
  }

  $('.js__playableSvg').each(function() {
    new PlayableSvg($(this))
  })
}
